import React, { useState, useEffect } from 'react';
import Layout from '../../components/ui/Layout';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import SubHeader from '../../components/ui/SubHeader';
import ActionBoxes from '../../components/ui/ActionBoxes';
import DocumentCategoryCard from './components/DocumentCategoryCard';
import TemplateListItem from './components/TemplateListItem';
import DocumentPreview from './components/DocumentPreview';
import GenerationOptionsPanel from './components/GenerationOptionsPanel';
import DocumentFormModal from './components/DocumentFormModal';
import BulkGenerationModal from './components/BulkGenerationModal';
import PropertyListingActionsModal from './components/PropertyListingActionsModal';
import ClientIntakeActionsModal from './components/ClientIntakeActionsModal';
import ContractsActionsModal from './components/ContractsActionsModal';
import OwnerAgreementsActionsModal from './components/OwnerAgreementsActionsModal';
import ReportsActionsModal from './components/ReportsActionsModal';
import TemplateSettingsModal from './components/TemplateSettingsModal';
import AIContractGeneratorModal from './components/AIContractGeneratorModal';
import ESignatureModal from './components/ESignatureModal';





const DocumentAndFormGenerationCenter = () => {
  const [selectedCategory, setSelectedCategory] = useState('property-listing');
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [activeActionModal, setActiveActionModal] = useState(null);
  const [isAIContractModalOpen, setIsAIContractModalOpen] = useState(false);
  const [isESignatureModalOpen, setIsESignatureModalOpen] = useState(false);
  const [selectedContract, setSelectedContract] = useState(null);
  const [formData, setFormData] = useState({
    propertyName: '',
    propertyType: '',
    realEstateType: '',
    location: '',
    price: '',
    ownerName: '',
    ownerPhone: '',
    ownerEmail: '',
    ownerId: '',
    additionalDetails: '',
    remarks: '',
    paperSize: 'a4',
    orientation: 'portrait',
    format: 'pdf',
    copies: 1,
    includeLogo: true,
    includeSignature: false,
    includeReference: true,
    includeTimestamp: true,
    sendEmail: false,
    sendWhatsApp: false,
    saveToArchive: true
  });

  useEffect(() => {
    const handleOpenAIContract = () => {
      setIsAIContractModalOpen(true);
    };

    const handleOpenESignature = () => {
      // For demo, use first available contract or create a mock one
      const mockContract = {
        id: 'demo-contract-001',
        contract_number: 'C-2026-001',
        contract_type: 'إيجار',
        status: 'active'
      };
      setSelectedContract(mockContract);
      setIsESignatureModalOpen(true);
    };

    window.addEventListener('openAIContractGenerator', handleOpenAIContract);
    window.addEventListener('openESignatureModal', handleOpenESignature);

    return () => {
      window.removeEventListener('openAIContractGenerator', handleOpenAIContract);
      window.removeEventListener('openESignatureModal', handleOpenESignature);
    };
  }, []);

  // Document action boxes
  const documentActions = [
    {
      id: 'property-listing',
      icon: 'Building2',
      label: 'قوائم العقارات',
      color: '#3B82F6',
      bgGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(96, 165, 250, 0.25) 100%)',
      borderColor: 'rgba(59, 130, 246, 0.5)',
      onClick: () => setActiveActionModal('property-listing')
    },
    {
      id: 'client-intake',
      icon: 'UserPlus',
      label: 'استقبال العملاء',
      color: '#10B981',
      bgGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(52, 211, 153, 0.25) 100%)',
      borderColor: 'rgba(16, 185, 129, 0.5)',
      onClick: () => setActiveActionModal('client-intake')
    },
    {
      id: 'contracts',
      icon: 'FileText',
      label: 'قوالب العقود',
      color: '#F59E0B',
      bgGradient: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(251, 191, 36, 0.25) 100%)',
      borderColor: 'rgba(245, 158, 11, 0.5)',
      onClick: () => setActiveActionModal('contracts')
    },
    {
      id: 'owner-agreements',
      icon: 'FileCheck',
      label: 'اتفاقيات الملاك',
      color: '#EF4444',
      bgGradient: 'linear-gradient(135deg, rgba(239, 68, 68, 0.2) 0%, rgba(248, 113, 113, 0.25) 100%)',
      borderColor: 'rgba(239, 68, 68, 0.5)',
      onClick: () => setActiveActionModal('owner-agreements')
    },
    {
      id: 'reports',
      icon: 'BarChart3',
      label: 'التقارير',
      color: '#8B5CF6',
      bgGradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(167, 139, 250, 0.25) 100%)',
      borderColor: 'rgba(139, 92, 246, 0.5)',
      onClick: () => setActiveActionModal('reports')
    },
    {
      id: 'bulk-generate',
      icon: 'Copy',
      label: 'إنشاء جماعي',
      color: '#06B6D4',
      bgGradient: 'linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(34, 211, 238, 0.25) 100%)',
      borderColor: 'rgba(6, 182, 212, 0.5)',
      onClick: () => setIsBulkModalOpen(true)
    },
    {
      id: 'export-pdf',
      icon: 'Download',
      label: 'تصدير PDF',
      color: '#EC4899',
      bgGradient: 'linear-gradient(135deg, rgba(236, 72, 153, 0.2) 0%, rgba(244, 114, 182, 0.25) 100%)',
      borderColor: 'rgba(236, 72, 153, 0.5)',
      onClick: () => console.log('Export PDF')
    },
    {
      id: 'template-settings',
      icon: 'Settings',
      label: 'إعدادات القوالب',
      color: '#14B8A6',
      bgGradient: 'linear-gradient(135deg, rgba(20, 184, 166, 0.2) 0%, rgba(45, 212, 191, 0.25) 100%)',
      borderColor: 'rgba(20, 184, 166, 0.5)',
      onClick: () => setActiveActionModal('template-settings')
    }
  ];

  const documentCategories = [
    {
      id: 'property-listing',
      name: 'نماذج قوائم العقارات',
      description: 'نماذج لإنشاء قوائم العقارات والإعلانات',
      icon: 'Building2',
      templateCount: 12,
      usageCount: 456
    },
    {
      id: 'client-intake',
      name: 'نماذج استقبال العملاء',
      description: 'نماذج لجمع معلومات العملاء الجدد',
      icon: 'UserPlus',
      templateCount: 8,
      usageCount: 342
    },
    {
      id: 'contracts',
      name: 'قوالب العقود',
      description: 'عقود الإيجار والبيع والشراكة',
      icon: 'FileText',
      templateCount: 15,
      usageCount: 789
    },
    {
      id: 'owner-agreements',
      name: 'اتفاقيات الملاك',
      description: 'اتفاقيات التفويض والإدارة',
      icon: 'FileCheck',
      templateCount: 10,
      usageCount: 234
    },
    {
      id: 'reports',
      name: 'التقارير',
      description: 'تقارير الأداء والإحصائيات',
      icon: 'BarChart3',
      templateCount: 6,
      usageCount: 567
    }
  ];

  const templates = {
    'property-listing': [
      {
        id: 'pl-1',
        name: 'نموذج قائمة العقار الأساسي',
        description: 'نموذج شامل لإدراج تفاصيل العقار مع الصور والمواصفات الكاملة',
        pageCount: 2,
        lastUpdated: '٢٠٢٦/٠١/٠٨',
        isNew: false
      },
      {
        id: 'pl-2',
        name: 'نموذج قائمة العقار المختصر',
        description: 'نموذج مختصر للإعلانات السريعة والمنصات الإلكترونية',
        pageCount: 1,
        lastUpdated: '٢٠٢٦/٠١/٠٥',
        isNew: false
      },
      {
        id: 'pl-3',
        name: 'نموذج قائمة العقار الفاخر',
        description: 'نموذج مخصص للعقارات الفاخرة مع تصميم احترافي وتفاصيل موسعة',
        pageCount: 4,
        lastUpdated: '٢٠٢٦/٠١/١٠',
        isNew: true
      }
    ],
    'client-intake': [
      {
        id: 'ci-1',
        name: 'نموذج استقبال العميل الشامل',
        description: 'نموذج كامل لجمع معلومات العميل ومتطلباته وتفضيلاته',
        pageCount: 3,
        lastUpdated: '٢٠٢٦/٠١/٠٧',
        isNew: false
      },
      {
        id: 'ci-2',
        name: 'نموذج استقبال العميل السريع',
        description: 'نموذج مختصر للمعلومات الأساسية فقط',
        pageCount: 1,
        lastUpdated: '٢٠٢٦/٠١/٠٩',
        isNew: true
      }
    ],
    'contracts': [
      {
        id: 'ct-1',
        name: 'عقد إيجار سكني',
        description: 'عقد إيجار قياسي للوحدات السكنية مع جميع الشروط القانونية',
        pageCount: 6,
        lastUpdated: '٢٠٢٦/٠١/٠٦',
        isNew: false
      },
      {
        id: 'ct-2',
        name: 'عقد بيع عقار',
        description: 'عقد بيع شامل مع كافة البنود القانونية المطلوبة',
        pageCount: 8,
        lastUpdated: '٢٠٢٦/٠١/٠٤',
        isNew: false
      }
    ],
    'owner-agreements': [
      {
        id: 'oa-1',
        name: 'اتفاقية تفويض إدارة',
        description: 'اتفاقية تفويض المالك للوكالة لإدارة العقار',
        pageCount: 4,
        lastUpdated: '٢٠٢٦/٠١/٠٣',
        isNew: false
      }
    ],
    'reports': [
      {
        id: 'rp-1',
        name: 'تقرير الأداء الشهري',
        description: 'تقرير شامل للأداء والإحصائيات الشهرية',
        pageCount: 5,
        lastUpdated: '٢٠٢٦/٠١/٠١',
        isNew: false
      }
    ]
  };

  const breadcrumbItems = [
    { label: 'الرئيسية', path: '/property-management-dashboard', icon: 'Home' },
    { label: 'مركز إنشاء المستندات', path: '/document-and-form-generation-center', icon: 'FileText' }
  ];

  const handleQuickMenuToggle = () => {
    console.log('Quick menu toggled');
  };

  const handleManageTemplates = () => {
    console.log('Opening template management');
    alert('إدارة القوالب - قريباً');
  };

  const quickActions = [
    {
      label: 'إنشاء مستند جديد',
      icon: 'FilePlus',
      onClick: () => setIsFormModalOpen(true),
      roles: ['admin', 'property_manager'],
      variant: 'primary'
    },
    {
      label: 'إنشاء مجمع',
      icon: 'Files',
      onClick: () => setIsBulkModalOpen(true),
      roles: ['admin'],
      variant: 'default'
    },
    {
      label: 'إدارة القوالب',
      icon: 'Settings',
      onClick: handleManageTemplates,
      roles: ['admin'],
      variant: 'default'
    }
  ];

  const currentTemplates = templates?.[selectedCategory] || [];
  const filteredTemplates = currentTemplates?.filter(template =>
    template?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    template?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
  };

  const handleFormSubmit = (values) => {
    setFormData({ ...formData, ...values });
    setIsFormModalOpen(false);
  };

  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      alert('تم إنشاء المستند بنجاح!');
    }, 2000);
  };

  const handlePrint = () => {
    window.print();
  };

  const handleBulkGenerate = (data) => {
    console.log('Bulk generate:', data);
    setIsBulkModalOpen(false);
    alert(`جاري إنشاء ${data?.properties?.length} مستند...`);
  };

  const handleExportDocument = (format) => {
    console.log('Exporting document as:', format);
    alert(`جاري تصدير المستند بصيغة ${format}...`);
  };

  const handleSaveTemplate = () => {
    console.log('Saving as template');
    alert('تم حفظ القالب بنجاح');
  };

  const actionBoxesConfig = [
    {
      id: 'new-document',
      icon: 'FilePlus',
      label: 'مستند جديد',
      color: '#3B82F6',
      bgGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(96, 165, 250, 0.25) 100%)',
      borderColor: 'rgba(59, 130, 246, 0.5)',
      onClick: () => console.log('New Document')
    },
    {
      id: 'templates',
      icon: 'FileText',
      label: 'القوالب',
      color: '#8B5CF6',
      bgGradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(167, 139, 250, 0.25) 100%)',
      borderColor: 'rgba(139, 92, 246, 0.5)',
      onClick: () => console.log('Templates')
    },
    {
      id: 'bulk-generate',
      icon: 'Files',
      label: 'إنشاء جماعي',
      color: '#10B981',
      bgGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(52, 211, 153, 0.25) 100%)',
      borderColor: 'rgba(16, 185, 129, 0.5)',
      onClick: () => console.log('Bulk Generate')
    }
  ];

  return (
    <Layout
      userRole="admin"
      userName="أحمد محمد"
      onQuickMenuToggle={handleQuickMenuToggle}
    >
      <SubHeader pageTitle="المستندات والنماذج" />
      <ActionBoxes 
        actions={documentActions}
        showNewContractModal={false}
        setShowNewContractModal={() => {}}
        contractTypeConfig={{}}
      />
      <div className="min-h-screen bg-background p-4 md:p-6 lg:p-8">
        <div className="space-y-4 md:space-y-6">
          <div>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-4">
              <div>
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
                  مركز إنشاء المستندات والنماذج
                </h1>
                <p className="text-sm md:text-base text-muted-foreground mt-2">
                  إنشاء وإدارة المستندات والنماذج بتنسيق عربي احترافي
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Button
                  variant="outline"
                  iconName="Download"
                  iconPosition="right"
                >
                  تصدير
                </Button>
                <Button
                  variant="default"
                  iconName="FilePlus"
                  iconPosition="right"
                  onClick={() => {
                    if (selectedTemplate) {
                      setIsFormModalOpen(true);
                    } else {
                      alert('الرجاء اختيار قالب أولاً');
                    }
                  }}
                >
                  مستند جديد
                </Button>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 md:gap-6 min-h-[calc(100vh-300px)]">
            <div className="lg:col-span-1 space-y-4">
              <div className="bg-card rounded-lg border border-border p-4 md:p-6">
                <h2 className="text-base md:text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
                  <Icon name="FolderOpen" size={20} />
                  فئات المستندات
                </h2>
                <div className="space-y-3">
                  {documentCategories?.map((category) => (
                    <DocumentCategoryCard
                      key={category?.id}
                      category={category}
                      isSelected={selectedCategory === category?.id}
                      onClick={() => {
                        setSelectedCategory(category?.id);
                        setSelectedTemplate(null);
                      }}
                    />
                  ))}
                </div>
              </div>

              <div className="bg-card rounded-lg border border-border p-4 md:p-6">
                <h2 className="text-base md:text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
                  <Icon name="FileText" size={20} />
                  القوالب المتاحة
                </h2>
                <Input
                  type="search"
                  placeholder="بحث في القوالب..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e?.target?.value)}
                  className="mb-4"
                />
                <div className="space-y-3 max-h-96 overflow-auto">
                  {filteredTemplates?.length > 0 ? (
                    filteredTemplates?.map((template) => (
                      <TemplateListItem
                        key={template?.id}
                        template={template}
                        isSelected={selectedTemplate?.id === template?.id}
                        onSelect={() => handleTemplateSelect(template)}
                        onPreview={() => handleTemplateSelect(template)}
                      />
                    ))
                  ) : (
                    <div className="text-center py-8">
                      <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
                      <p className="text-sm text-muted-foreground mt-2">
                        لا توجد قوالب متطابقة
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="lg:col-span-2 bg-card rounded-lg border border-border overflow-hidden">
              <DocumentPreview
                template={selectedTemplate}
                formData={formData}
                onEdit={() => setIsFormModalOpen(true)}
              />
            </div>

            <div className="lg:col-span-1">
              <GenerationOptionsPanel
                formData={formData}
                onFormDataChange={setFormData}
                onGenerate={handleGenerate}
                onPrint={handlePrint}
                isGenerating={isGenerating}
              />
            </div>
          </div>
        </div>
      </div>
      <DocumentFormModal
        isOpen={isFormModalOpen}
        onClose={() => setIsFormModalOpen(false)}
        template={selectedTemplate}
        onSubmit={handleFormSubmit}
        documentType={selectedCategory}
      />
      <BulkGenerationModal
        isOpen={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        onGenerate={handleBulkGenerate}
      />
      <PropertyListingActionsModal
        isOpen={activeActionModal === 'property-listing'}
        onClose={() => setActiveActionModal(null)}
      />
      <ClientIntakeActionsModal
        isOpen={activeActionModal === 'client-intake'}
        onClose={() => setActiveActionModal(null)}
      />
      <ContractsActionsModal
        isOpen={activeActionModal === 'contracts'}
        onClose={() => setActiveActionModal(null)}
      />
      <OwnerAgreementsActionsModal
        isOpen={activeActionModal === 'owner-agreements'}
        onClose={() => setActiveActionModal(null)}
      />
      <ReportsActionsModal
        isOpen={activeActionModal === 'reports'}
        onClose={() => setActiveActionModal(null)}
      />
      {activeActionModal === 'template-settings' && (
        <TemplateSettingsModal
          isOpen={activeActionModal === 'template-settings'}
          onClose={() => setActiveActionModal(null)}
        />
      )}

      <AIContractGeneratorModal
        isOpen={isAIContractModalOpen}
        onClose={() => setIsAIContractModalOpen(false)}
      />

      <ESignatureModal
        isOpen={isESignatureModalOpen}
        onClose={() => setIsESignatureModalOpen(false)}
        contract={selectedContract}
      />
    </Layout>
  );
};

export default DocumentAndFormGenerationCenter;